let memoizedColumns = []
const WorkflowstateColumns = () => {
    if (memoizedColumns.length > 0) {
        return memoizedColumns
    }
    memoizedColumns = [
        {
            accessorKey: 'checkbox',
            header: '',
        },
        {
            accessorKey: 'state',
            header: 'State',
        }
    ]
    return memoizedColumns
}

export default WorkflowstateColumns;